module.exports = typeof Promise === 'function' ? Promise : require('lie');



/*****************
 ** WEBPACK FOOTER
 ** ./~/native-or-lie/index.js
 ** module id = 4
 ** module chunks = 0
 **/